var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4472 4.24834C14.4812 4.18342 14.5301 4.12748 14.5899 4.08513C14.6498 4.04278 14.7188 4.01523 14.7914 4.00476C14.864 3.99428 14.938 4.00117 15.0074 4.02486C15.0768 4.04855 15.1396 4.08837 15.1906 4.14103L15.7311 4.49963C15.8604 4.59859 15.9541 4.73683 15.998 4.89355C16.012 5.08753 15.9517 5.27958 15.8292 5.43077L9.92166 14.9242C9.7882 15.1395 9.68544 15.2828 9.58401 15.4261C9.49914 15.5593 9.3833 15.6699 9.24636 15.7487C9.14169 15.8222 9.02827 15.8825 8.90871 15.928C8.78964 15.9723 8.66405 15.9967 8.53703 16C8.30621 15.9945 8.08245 15.9195 7.89509 15.7847C7.60326 15.5671 7.3517 15.3002 7.15173 14.9962L4.11222 10.6977C4.06579 10.6518 4.03205 10.5946 4.01428 10.5318C3.99651 10.4689 3.9953 10.4026 4.01079 10.3391C4.04603 10.2327 4.10358 10.135 4.17961 10.0525L4.82155 9.4793C4.90109 9.39469 5.00987 9.34346 5.12583 9.336C5.23904 9.35325 5.34477 9.40304 5.43012 9.4793L8.3662 11.9515L14.4472 4.24834Z",
    fill: "#7EBFED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlue);
export default __webpack_public_path__ + "static/media/check-blue.019f5c98e606a4c62ecfa04afefbbbc5.svg";
export { ForwardRef as ReactComponent };